import DeviceActivationLogsTable from './DeviceActivationLogsTable';

export default DeviceActivationLogsTable;
